// Generated sandbox code: SSVMN - PlusTools - Editor v6.4.1 - 02/12/2020
// Created/Updated by Developer - 4/15/2021

import { Component, OnDestroy } from '@angular/core'
import { ActivatedRoute } from '@angular/router';
import { CtFormComponent, CtStepperComponent, CtStepperItemComponent, ADN_PLUS, HttpService, CtSelectComponent, CtInputFileComponent, CtLabelComponent, CtButtonComponent, CtColumnComponent, CtRowComponent, CtDialogComponent, Action, ActionType} from 'components';
import { BaseController } from './base.controller';
import { Router } from "@angular/router";
import { Subscription } from 'rxjs';

@Component({
  selector: 'av-vi01',
  template: `<div [id]="getId()" #target><div>`
})

export class AvVi01 extends BaseController implements OnDestroy {

  numCliente;
  numItemContact;
  indVerificado
  otp
  creationUrl;
  private subscriptions : Subscription[] = [];


  constructor(private routerParams: ActivatedRoute, private router: Router) {
    super();
    super.setViewCode('AV_VI01');
    this.subscriptions.push(this.routerParams.queryParams.subscribe(params => {
      let paramString = Object.keys(params)[0];

      if (paramString) {
        let paramsObject = JSON.parse('{"' + paramString.replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');

        this.numItemContact = paramsObject.ni;
        this.indVerificado = paramsObject.v;
        this.numCliente = paramsObject.ncs;
        this.otp = paramsObject.k;
      }

      this.verifyOtpCode()
    }));
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /* ---------------------- CONTROLLER LOGIC ------------------- */

  initializeView(evt) {
    let stepper = this.utilService.getComponentRef(evt.actionParams[0]) as CtStepperComponent;
    let colMedCon = this.utilService.getComponentRef(evt.actionParams[1]) as CtColumnComponent;
    let stepperItems = stepper.getStepperItems();

    for (let i = 1; i < stepperItems.length; i++) {
      const step = stepperItems[i] as CtStepperItemComponent;
      step.setReadOnly(true);
    }
    if (!this.numItemContact && !this.numCliente) {
      colMedCon.setHidden(false);
    }
  }

  checkStep(evt) {
    let validStep = true;
    let stepper = this.utilService.getComponentRef(evt.actionParams[0]) as CtStepperComponent;
    let stepForm = this.utilService.getComponentRef(evt.actionParams[1]) as CtFormComponent;


    for (const el of stepForm.getFormElements()) {
      if (el.required && !el.getValue() && el.getCtType() != 'CtInputFile' && el.getModelId() != 'COMENTARIO') {
        validStep = false;
      } else if (el.required && el.getCtType() == 'CtInputFile' && el.getFiles().length <= 0) {
        validStep = false;
      }

      if (el.getModelId() == 'NUM_SUCURSAL_TRAM' && el.getValue() == 21) {

        this.plusAlertService.setCtDialogInfo('Alerta', 'confirmation', 'caution', 'primary', 'Estimada persona asociada, para poder realizar su gestión por medio de la sucursal virtual (vía Zoom) es indispensable que posea una firma digital, obtenida por medio de alguna entidad autorizada en Costa Rica.',
          true, 'Aceptar', 'Cancelar');


      }
    }

    stepper.changeNextState(!validStep);
  }

  onNextStep(evt, res) {
    let stepper = this.utilService.getComponentRef(evt.actionParams[0]) as CtStepperComponent;
    let data = new ADN_PLUS();
    let num_cliente;
    let list = [];

    if (stepper.getCurrentIndex() != 0) {
      if (stepper.canNext()) {
        this.plusAlertService.setCtDialogInfo('ATENCIÓN', 'downloadError', 'downloadError', 'primary',
        stepper.getSelectedStepperItem().getDisabledMessage(), true, 'De acuerdo', 'Cancelar');
        return false;
      }

      for (let i = 1; i <= (evt.actionParams.length - 1); i++) {
        const stepForm = this.utilService.getComponentRef(evt.actionParams[i]) as CtFormComponent;
        const newItems = stepForm.getBindingAdn().ArrayEntities.List;
        list = [...list, ...newItems];
      }

      data.ArrayEntities.List = list;
    }

    if (this.loggedUser?.user.num_cliente_sigma) {
      num_cliente = this.loggedUser.user.num_cliente_sigma;
    } else {
      num_cliente = this.numCliente;
    }

    let contRequest = {
      "Type": 1,
      "UserCode": "SVA",
      "Source": "SVA",
      "Conditions":
      {
        "Data": [{
          "Name": "NUM_CLIENTE",
          "Alias": "NUM_CLIENTE",
          "Value": num_cliente,
          "Display": "",
          "Type": 1,
          "FamilyId": ""
        },
        {
          "Name": "STEP",
          "Alias": "STEP",
          "Value": stepper.getCurrentIndex(),
          "Display": "",
          "Type": 1,
          "FamilyId": ""
        }]
      },
      "Data": [data],
      "Files": []
    }

    if (data) {
      return this.httpService.post(HttpService.ENDPOINT + '/api/process/PRE_SOLICITUD_CRED/SER_VALIDATE_BEFORE_STEPS', contRequest)
    }
  }

  sendInfoToVeriFy(evt) {

    let data = new ADN_PLUS();
    let list = [];
    const step = this.utilService.getComponentRef(evt.actionParams[0]) as CtStepperComponent;
    const form = this.utilService.getComponentRef(evt.actionParams[1]) as CtFormComponent;
    const adn = form.getBindingAdn();

    if (step.getCurrentIndex() != (step.getStepperItems().length - 2)) {
      return false;
    }

    //if(step.getCurrentIndex() !== step.stepperItems.length - 1) {
    //  this.plusAlertService.setCtDialogInfo('ATENCIÓN', 'downloadError', 'downloadError', 'primary',
    //  step.getSelectedStepperItem().getDisabledMessage(), true, 'De acuerdo', 'Cancelar');
    //  return false;
    //}

    for (let i = 1; i < evt.actionParams.length; i++) {
      const stepForm = this.utilService.getComponentRef(evt.actionParams[i]) as CtFormComponent;
      const newItems = stepForm.getBindingAdn().ArrayEntities.List;
      list = [...list, ...newItems];
    }

    data.ArrayEntities.List = list;
    let num_cliente;

    if (this.loggedUser?.user.num_cliente_sigma) {
      num_cliente = this.loggedUser.user.num_cliente_sigma;
    } else {
      num_cliente = this.numCliente;
      data.addAttribute('NUM_ITEM', this.numItemContact)
      data.addAttribute('IND_NUEVO', this.indVerificado)
    }

    data.addAttribute('MED_VERIFICA', adn.getStringAttribute('MEDIO_CONTACTO'))
    data.addAttribute('NUM_CLIENTE', num_cliente)

    if (data) {
      return this.httpService.post(HttpService.ENDPOINT + '/api/SigmaApps/CL/Serv/CreditPresol', data)
    }

  }

  createPresolCred(evt) {

    let data = new ADN_PLUS();
    let list = [];
    const inputFile = this.utilService.getComponentRef(evt.actionParams[3]) as CtInputFileComponent;

    for (let i = 0; i < (evt.actionParams.length - 1); i++) {
      const stepForm = this.utilService.getComponentRef(evt.actionParams[i]) as CtFormComponent;
      const newItems = stepForm.getBindingAdn().ArrayEntities.List;
      list = [...list, ...newItems];
    }

    data.ArrayEntities.List = list;

    if (evt.confirmField && evt.confirmValue) {
      data.addAttribute(evt.confirmField, evt.confirmValue);
    }
    let num_cliente;

    if (this.loggedUser?.user.num_cliente_sigma) {
      num_cliente = this.loggedUser.user.num_cliente_sigma;
    } else {
      num_cliente = this.numCliente;
      data.addAttribute('NUM_ITEM', this.numItemContact)
      data.addAttribute('IND_NUEVO', this.indVerificado)
    }

    data.addAttribute('NUM_CLIENTE', num_cliente)

    let contRequest = {
      "Type": 0,
      "UserCode": "SVA",
      "Source": "SVA",
      "Conditions":
      {
        "Data": [{
          "Name": "NUM_CLIENTE",
          "Alias": "NUM_CLIENTE",
          "Value": num_cliente,
          "Display": "",
          "Type": 1,
          "FamilyId": ""
        }, {
          "Name": evt.confirmField,
          "Alias": evt.confirmField,
          "Value": evt.confirmValue,
          "Display": "",
          "Type": 1,
          "FamilyId": ""
        }]
      },
      "Data": [data],
      "Files": [...inputFile.getProcessedFiles()]
    }

    if (data) {
      return this.httpService.post(HttpService.ENDPOINT + '/api/process/PRE_SOLICITUD_CRED/SER_CREAR_PRESOLICITUD', contRequest)
    }
  }

  finalStep(evt, res) {
    let stepper = this.utilService.getComponentRef(evt.actionParams[0]) as CtStepperComponent;
    let lbl = this.utilService.getComponentRef(evt.actionParams[1]) as CtLabelComponent;
    let btn = this.utilService.getComponentRef(evt.actionParams[2]) as CtButtonComponent;

    let resADN = new ADN_PLUS(res instanceof Array ? res[0] : res);
    let message;

    if (resADN.getStringAttribute('IN_EX_USR') != 'S') {
      message = resADN.getStringAttribute('MESSAGE') + resADN.getStringAttribute('MESSAGE_2')
      this.creationUrl = resADN.getStringAttribute('CREATE_URL');
      btn.setHidden(false);
    } else {
      message = resADN.getStringAttribute('MESSAGE');
    }

    if (resADN.getStringAttribute('IND_VERIFY') == 'N') {
      this.creationUrl = resADN.getStringAttribute('CREATE_URL');
      btn.setHidden(false);
      btn.setButtonText('Ver el estado de la gestión');
    }

    lbl.setLabelValue(message);

    stepper.changeNextState();
    stepper.changeStep(stepper.getCurrentIndex() + 1);
    return { Data: res }
  }

  goToUserCreation(evt) {
    location.href = this.creationUrl;
  }

  finishProcess() {
    this.router.navigate(['/']);
  }

  disableProcess(e, r) {
    let mainRow = this.utilService.getComponentRef(e.actionParams[0]) as CtRowComponent;
    let helpRow = this.utilService.getComponentRef(e.actionParams[1]) as CtRowComponent;
    let headRow = this.utilService.getComponentRef(e.actionParams[2]) as CtRowComponent;

    let adn = new ADN_PLUS(r instanceof Array ? r[0] : r)

    if (adn.getStringAttribute('HAS_PRESOL') == 'S') {
      headRow.setHidden(true);
      mainRow.setHidden(true);
      helpRow.setHidden(false);
    } else {
      headRow.setHidden(false);
      mainRow.setHidden(false);
      helpRow.setHidden(true);
    }

    if (adn.getStringAttribute('HAS_ERROR') == 'S') {
      headRow.setHidden(true);
      mainRow.setHidden(true);
     this.plusAlertService.setCtDialogInfo('Error', 'error', 'caution', 'primary', adn.getStringAttribute('ERROR_MSG'),
        true, 'Aceptar', null);

        setTimeout(() => {
          this.router.navigate(['/home/view/AV_VI05']);
        }, 5000);

    }
  }


  ///	this.plusAlertService.showAlertDialog('Error', adn.getStringAttribute('ERROR_MSG'), 'error', 'Volver al inicio', null, () => {
  //		this.router.navigate(['/']);
  //	})
  //}



  exitFromView(e, r) {
    this.router.navigate(['/home/view/AV_VI03']);
  }

  saveOnLaser(evt, r) {
    let data = new ADN_PLUS();
    let list = [];
    const inputFile = this.utilService.getComponentRef(evt.actionParams[3]) as CtInputFileComponent;

    for (let i = 0; i < (evt.actionParams.length - 1); i++) {
      const stepForm = this.utilService.getComponentRef(evt.actionParams[i]) as CtFormComponent;
      const newItems = stepForm.getBindingAdn().ArrayEntities.List;
      list = [...list, ...newItems];
    }

    data.ArrayEntities.List = list;

    if (evt.confirmField && evt.confirmValue) {
      data.addAttribute(evt.confirmField, evt.confirmValue);
    }
    let num_cliente;

    if (this.loggedUser?.user.num_cliente_sigma) {
      num_cliente = this.loggedUser.user.num_cliente_sigma;
    } else {
      num_cliente = this.numCliente;
      data.addAttribute('NUM_ITEM', this.numItemContact)
    }


    // data.addAttribute('NUM_CLIENTE', num_cliente)

    let adn = new ADN_PLUS((r instanceof Array ? r[0] : r));

    let nameArray = adn.getStringAttribute('NOMBRE_COMPLETO').split(' ');

    let files = [...inputFile.getProcessedFiles()];

    let contRequest = {
      "Type": 3,
      "UserCode": "SVA",
      "Source": "SVA",
      "Conditions": {
        "Data": [
          {
            "Name": "PARENT_ID",
            "Alias": "PARENT_ID",
            "Value": "47",
            "Type": 1
          },
          {
            "Name": "RENAME",
            "Alias": "RENAME",
            "Value": "true",
            "Type": 1
          },
          {
            "Name": "TEMPLATE_NAME",
            "Alias": "TEMPLATE_NAME",
            "Value": "Solicitudes de Crédito",
            "Type": 1
          },
          {
            "Name": "FILE_NAME",
            "Alias": "FILE_NAME",
            "Value": num_cliente,
            "Type": 1
          }
        ]
      },
      "Data": [
        {
          "ArrayEntities": {
            "List": [
              {
                "Name": "METADATA",
                "Alias": "NUM_CLIENTE",
                "Value": num_cliente,
                "Type": 1
              },
              {
                "Name": "METADATA",
                "Alias": "DOC_IDENTIFICACION",
                "Value": adn.getStringAttribute('DOC_IDENTIFICACION'),
                "Type": 1
              },
              {
                "Name": "METADATA",
                "Alias": "NOMBRE",
                "Value": nameArray[2],
                "Type": 1
              },
              {
                "Name": "METADATA",
                "Alias": "APELLIDO_1",
                "Value": nameArray[0],
                "Type": 1
              },
              {
                "Name": "METADATA",
                "Alias": "APELLIDO_2",
                "Value": nameArray[1],
                "Type": 1
              },
              {
                "Name": "METADATA",
                "Alias": "NUM_OBJETO",
                "Value": adn.getStringAttribute('NUM_SOL'),
                "Type": 1
              },
              {
                "Name": "METADATA",
                "Alias": "COD_OBJETO",
                "Value": data.getStringAttribute('COD_OBJETO_LINEA'),
                "Type": 1
              },
              {
                "Name": "METADATA",
                "Alias": "FEC_FORMALIZA",
                "Value": this.utilService.parseUiDateToDbDate(new Date()),
                "Type": 12
              },
              {
                "Name": "METADATA",
                "Alias": "EST_SOLIC",
                "Value": "RE",
                "Type": 1
              }
            ]
          }
        }
      ],
      "Files": []
    }
    // Archivos
    for (let i = 0; i < files.length; i++) {
      const el = files[i];
      contRequest.Conditions.Data[3].Value = contRequest.Conditions.Data[3].Value + el.name.substr(el.name.lastIndexOf('.'));
      contRequest.Files = [el]
      this.subscriptions.push(this.httpService.post(HttpService.ENDPOINT + '/api/process/LASERFICHE/CRE_DEFAULT', contRequest).subscribe(() => { }))
    }
    // this.httpService.post(HttpService.ENDPOINT + '/api/process/LASERFICHE/CRE_DEFAULT', contRequest).subscribe(() => { })

    // File en blanco 
    contRequest.Conditions.Data[2].Value = "Información de Crédito";
    contRequest.Conditions.Data[3].Value = num_cliente

    // data.addAttribute('NUM_CLIENTE', num_cliente);

    // for (const ae of data.ArrayEntities.List) {
    // 	ae.Name = 'METADATA';
    // }

    contRequest.Data = [{
      "ArrayEntities": {
        "List": [{
          "Name": "METADATA",
          "Alias": "NUM_CLIENTE",
          "Value": num_cliente,
          "Type": 1
        },
        {
          "Name": "METADATA",
          "Alias": "IND_MEP_JUPEMA",
          "Value": data.getStringAttribute('IND_MEP_JUPEMA'),
          "Type": 1
        },
        {
          "Name": "METADATA",
          "Alias": "COND_LABORAL",
          "Value": data.getStringAttribute('COND_LABORAL'),
          "Type": 1
        },
        {
          "Name": "METADATA",
          "Alias": "TIEMPO_LABORA",
          "Value": data.getStringAttribute('TIEMPO_LABORA'),
          "Type": 1
        },
        {
          "Name": "METADATA",
          "Alias": "SALARIO_BRUTO",
          "Value": data.getStringAttribute('SALARIO_BRUTO'),
          "Type": 1
        },
        {
          "Name": "METADATA",
          "Alias": "SALARIO_NETO",
          "Value": data.getStringAttribute('SALARIO_NETO'),
          "Type": 1
        },
        {
          "Name": "METADATA",
          "Alias": "COD_OBJETO_LINEA",
          "Value": data.getStringAttribute('COD_OBJETO_LINEA'),
          "Type": 1
        },
        {
          "Name": "METADATA",
          "Alias": "MONTO_SOLICITUD",
          "Value": data.getStringAttribute('MONTO_SOLICITUD'),
          "Type": 1
        },
        {
          "Name": "METADATA",
          "Alias": "NUM_SUCURSAL_TRAM",
          "Value": data.getStringAttribute('NUM_SUCURSAL_TRAM'),
          "Type": 1
        }]
      }
    }

    ]

    contRequest.Files = []

    this.subscriptions.push(this.httpService.post(HttpService.ENDPOINT + '/api/process/LASERFICHE/CRE_DEFAULT', contRequest).subscribe(() => { }));



  }

  setDestinationValue(e, r) {
    const selectCodObjeto = this.utilService.getComponentRef(e.actionParams[0]) as CtSelectComponent;
    const selectEncuesta = this.utilService.getComponentRef(e.actionParams[1]) as CtSelectComponent;

    selectEncuesta.setHidden(true);

    switch (selectCodObjeto.getValue()) {
      case 'S_CRE_FUN':
        selectEncuesta.setValue("Funerario");
        break;
      case 'S_CRE_MAR':
        selectEncuesta.setValue("Marchamo");
        break;
      case 'S_CRE_HIP':
        selectEncuesta.setValue("Compra bienes");
        break;
      case 'S_CRE_SAL':
        selectEncuesta.setValue("Salud");
        break;
      case 'S_CRE_SIN':
        selectEncuesta.setValue("Reparaciones/mejoras a vivienda");
        break;
      default:
        selectEncuesta.setValue(null);
        selectEncuesta.setHidden(false);
        break;
    }



    if (selectCodObjeto.getValue() == 'S_CRE_HIP') {

      this.plusAlertService.setCtDialogInfo('Alerta', 'downloadError', 'caution', 'primary', 'La tasa interés puede variar de acuerdo con la cantidad de bienes inmuebles registrados a su nombre y del cónyuge.\nLa cuota no incluye pólizas (incendios y PSD). Esta línea requiere que exista un bien inmueble (propiedad) para hipotecar.',
        true, 'De acuerdo', 'De acuerdo');

    } else if (selectCodObjeto.getValue() == 'S_CRE_LIH') {

      this.plusAlertService.setCtDialogInfo('Alerta', 'downloadError', 'caution', 'primary', 'La cuota no incluye pólizas (incendios y PSD).  Esta línea requiere que exista un bien inmueble (propiedad) para hipotecar a nombre del asociado y/o núcleo familiar.',
        true, 'De acuerdo', 'De acuerdo');
    }

  }

  verifyOtpCode() {
    this.subscriptions.push(this.httpService.get(`${HttpService.ENDPOINT}/api/account/ValidateOTPCode/${this.otp}`).subscribe((r) => { }, (e) => {
      if (!this.loggedUser?.user.num_cliente_sigma) {
        throw e;
      }
    }));
  }

  getCustomerLines(e, r) {

    const selectLabora = this.utilService.getComponentRef(e.actionParams[0]) as CtSelectComponent;
    const tipLabora = this.utilService.getComponentRef(e.actionParams[1]) as CtSelectComponent;

    let num_cliente;

    if (this.loggedUser?.user.num_cliente_sigma) {
      num_cliente = this.loggedUser.user.num_cliente_sigma;
    } else {
      num_cliente = this.numCliente;
    }

    let contRequest = {
      "Type": 0,
      "UserCode": "SVA",
      "Source": "SVA",
      "Conditions":
      {
        "Data": [{
          "Name": "NUM_CLIENTE",
          "Alias": "NUM_CLIENTE",
          "Value": num_cliente,
          "Display": "",
          "Type": 1,
          "FamilyId": ""
        }, {
          "Name": 'COND_LABORA',
          "Alias": 'COND_LABORAL',
          "Value": selectLabora.getValue(),
          "Display": "",
          "Type": 1,
          "FamilyId": ""
        },
        {
          "Name": 'TIP_LABORA',
          "Alias": 'TIP_LABORA',
          "Value": tipLabora.getValue(),
          "Display": "",
          "Type": 1,
          "FamilyId": ""
        }]
      },
      "Data": [],
      "Files": []
    }


    return this.httpService.post(HttpService.ENDPOINT + '/api/process/PRE_SOLICITUD_CRED/SER_RET_FILTERED_LINES', contRequest)

  }

  /* -------------------- END CONTROLLER LOGIC ----------------- */

}
